export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20geometric%20shapes%20and%20flowing%20fabric%20textures%20in%20warm%20terracotta%20sand%20and%20cream%20tones%20with%20a%20few%20scattered%20minimalist%20product%20silhouettes%20soft%20gradient%20lighting%20modern%20editorial%20design%20no%20text%20clean%20sophisticated%20background&width=1600&height=900&seq=hero-main-bg-v2-2026&orientation=landscape"
          alt="Modern abstract fashion and shopping aesthetic"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-0">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight tracking-tight">
              Smart
              <br />
              China Shopping
              <br />
              Starts Here
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-50/85 max-w-lg leading-relaxed">
              Discover how thousands of savvy international buyers are using the{' '}
              <strong className="text-background-50 font-semibold">itaobuyspreadsheet system</strong>{' '}
              to source products from Taobao, 1688, and Weidian — safer, cheaper, and faster than traditional shopping agents.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-8 py-3.5 text-base font-medium text-background-50 border-2 border-background-50/40 rounded-full hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                itaobuy sheet
                <i className="ri-external-link-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:pt-8">
            <div className="bg-background-50/10 backdrop-blur-sm border border-background-50/15 rounded-2xl p-6 md:p-8">
              <p className="text-background-50/80 text-sm md:text-base leading-relaxed">
                The <strong className="text-background-50">itaobuyspreadsheet</strong> method replaces traditional agents with a structured, transparent ordering workflow. Simply find products on any Chinese marketplace, add them to your spreadsheet, and submit — track everything in one place with complete pricing visibility and no hidden markups.
              </p>
              <a
                href="#what-is"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('what-is');
                  if (el) {
                    const offset = 72;
                    const top = el.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="inline-flex items-center gap-2 mt-5 text-sm font-medium text-accent-300 hover:text-accent-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn how it works
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}